import React from "react";
import {Button, useTheme} from "@mui/material";
import {SxProps} from "@mui/system";
import {Theme} from "@mui/material/styles";

export function SecondaryButton(props: {
  onClick: (event: React.MouseEvent<HTMLElement>) => void,
  title?: string,
  startIcon?: React.ReactNode,
  size?: 'small' | 'medium' | 'large',
  variant?: 'text' | 'outlined' | 'contained',
  sx?: SxProps<Theme>,
  fullWidth?: boolean,
}) {
  const theme = useTheme();
  const sx = {
    color: 'primary.main',
    [theme.breakpoints.down('sm')]: {
      minWidth: 100,
    },
    minWidth: 150,
  };

  return (
    <Button fullWidth={props.fullWidth} size={props.size || 'medium'} variant={props.variant || "outlined"} sx={{...sx, ...props.sx}}
            onClick={props.onClick} startIcon={props.startIcon}>
      {props.title}
    </Button>
  )
}
